const awsConfig = {
  Auth: {
    region: 'ap-northeast-1',
    userPoolId:
      import.meta.env.VITE_COGNITO_USER_POOL_ID || 'ap-northeast-1_P0YN2l8sy',
    userPoolWebClientId:
      import.meta.env.VITE_COGNITO_APP_CLIENT_ID ||
      '30f4bg3rmm0mvnmjee0j34vplc',
    identityPoolId:
      import.meta.env.VITE_COGNITO_IDENTITY_POOL_ID ||
      'ap-northeast-1:779efc13-2d28-4734-8a42-e680f13d8d20',
    // TODO: α版ユーザーの移行が完了したら、下記の設定を削除してデフォルトのUSER_SRP_AUTHに戻す
    // https://docs.aws.amazon.com/cognito/latest/developerguide/cognito-user-pools-import-using-lambda.html
    authenticationFlowType: 'USER_PASSWORD_AUTH',
  },
  Storage: {
    AWSS3: {
      bucket: 'cambia-job-seeker-production-storage',
      region: 'ap-northeast-1',
    },
  },
};

export default awsConfig;
